import React, { Fragment, useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DataGridPro from '@mui/x-data-grid-pro';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer, toast } from 'react-toastify';
import { ListsModal } from '../../contexts';
import Modal from '@mui/material/Modal';
import { Editor } from '@tinymce/tinymce-react';


const Marketing = ( { user, viewing } ) => {
    const [ gridHeight, setGridHeight ] = useState( 1 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ body, setBody ] = useState( '' );

    const editorRef = useRef( null );
    const containerRef = useRef( null );
    const titleRef = useRef( null );
    const gridRef = useRef( null );

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Playbooks</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                <Editor
                                    tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                    init={ { 
                                        menubar: false, 
                                        statusbar: false,
                                        toolbar_mode: 'wrap',
                                        visual: false,
                                        visualblocks_default_state: true,
                                        content_style: 'body { font-family:Arial; font-size:12pt }',
                                        setup: ( editor ) => {
                                            // editor.ui.registry.addButton( 'tfvideo', {
                                            //     icon: 'embed',
                                            //     tooltip: 'Insert Video',
                                            //     enabled: true,
                                            //     onAction: (_) => {
                                            //         setShowVideo( true );
                                            //     },
                                            // } );
                                            // editor.ui.registry.addMenuButton( 'tftmpl', {
                                            //     text: 'Insert Template...',
                                            //     fetch: ( cb ) => {
                                            //         const items = loadTemplates( editor );
                                            //         cb( items );
                                            //     }
                                            // } );
                                            // editor.ui.registry.addMenuButton( 'tfaiprompts', {
                                            //     icon: 'ai-prompt',
                                            //     fetch: ( cb ) => {
                                            //     const items = loadPromptMenu();
                                            //     cb( items );
                                            //     }
                                            // } );
                                            // editor.ui.registry.addButton( 'tfchatgpt', {
                                            //     icon: 'ai',
                                            //     tooltip: 'Ask MortgageGPT',
                                            //     onAction: () => {
                                            //         setShowChatGPT( true );
                                            //     }
                                            // });
                                            
                                            // editor.ui.registry.addContextMenu( 'aiContextMenu', {
                                            //     update: ( element ) => {
                                            //         const selectedText = editor.selection.getContent( { format: 'text' } );
                                            //         return selectedText ? loadPromptContextMenu( editor ) : ''; // Show the custom item if text is selected
                                            //     },
                                            // } );
                                        },
                                        browser_spellcheck: true,
                                        // contextmenu: 'aiContextMenu link'
                                    } }
                                    onInit={ ( evt, editor ) => {
                                        editorRef.current = editor;

                                        const contentDocument = editor.getDoc();
                                            const blocks = contentDocument.querySelectorAll('p, div, h1, h2, h3');

                                            blocks.forEach((block) => {
                                                block.setAttribute('draggable', true);

                                                // Add event listeners for drag-and-drop
                                                block.addEventListener('dragstart', (e) => {
                                                e.dataTransfer.setData('text/html', block.outerHTML);
                                                block.classList.add('dragging');
                                                });

                                                block.addEventListener('dragover', (e) => {
                                                e.preventDefault(); // Allow dropping
                                                block.style.borderTop = '2px solid #007BFF';
                                                });

                                                block.addEventListener('dragleave', () => {
                                                block.style.borderTop = '';
                                                });

                                                block.addEventListener('drop', (e) => {
                                                e.preventDefault();
                                                block.style.borderTop = '';
                                                const draggedHTML = e.dataTransfer.getData('text/html');
                                                const draggedElement = document.createElement('div');
                                                draggedElement.innerHTML = draggedHTML;

                                                // Insert the dropped content before the target block
                                                block.parentNode.insertBefore(draggedElement.firstElementChild, block);

                                                // Remove the dragging class from the original
                                                const draggingElement = contentDocument.querySelector('.dragging');
                                                if (draggingElement) draggingElement.remove();
                                                });

                                                block.addEventListener('dragend', () => {
                                                block.classList.remove('dragging');
                                                });
                                            });
                                    } }
                                    initialValue={body}
                                    plugins='visualblocks emoticons code lists link image'
                                    toolbar='visualblocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | align bullist numlist | link | image tfvideo emoticons tftmpl tfchatgpt tfaiprompts | code'
                                />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadLists
} );
  
export default connect( mapProps, mapDispatch )( Marketing );